import actions from './actions'
import mutations from './mutations'

const module = {
    actions,
    mutations,
    state: {
        list: [],
        detail: {},
        credList: []
    },
    getters: {
        products: state => state.list,
        productDetail: state => state.detail,
        productCredList: state => state.credList
    }
}

export default module
